export enum VoDossierPermissions {
  VoDossier = 'vo-dossier',
}
